export enum UserTypeEnum {
	DRIVER = 1,
	MANAGER = 3,
	ADMIN = 4,
}
